module.exports = class ValidationService {
  doHinValidation(event, validateHin, model, formControl, hasManitobaProduct) {
    if (validateHin) {
      if (event.key === ' ') {
        event.stopPropagation();
        event.preventDefault();
        return false;
      }
      setTimeout(() => this.validateHin(formControl.$viewValue, model, hasManitobaProduct), 0);
    }

    return true;
  }

  validateHin = (value, model, hasManitobaProduct) => {
    if (value) {
      let hinParts;

      if (!hasManitobaProduct) {
        const parsedParts = value.replace(/[^a-zA-Z0-9]/gi, '').match(/.{1,4}/g);
        hinParts = parsedParts && parsedParts.length ? parsedParts.join(' ').substr(0, 14) : '';
      } else {
        hinParts = value;
      }
      model.hin = hinParts;
    }
  }

  validateHinExpiryDate = (hinMonth, hinYear) => {
    const date = new Date();
    const currentMonth = date.getMonth() + 1;
    const currentYear = date.getFullYear();

    if (hinYear > currentYear) {
      return true;
    }

    if (hinYear === currentYear) {
      return hinMonth >= currentMonth;
    }

    return false;
  }
};



// WEBPACK FOOTER //
// ./main/services/validation-service.js